import type { CreateCastRelationshipBody } from '../../../domains/scene/services/sceneService';
import {
  buildCreateCastRelationshipBody,
  type CastMemberInput
} from '../../../domains/scene/ui/castRelationshipMapper';
import type { ScenePersona } from '../types';

const toCastMemberInput = (persona: ScenePersona): CastMemberInput => {
  const entityId = persona.entityId ?? persona.memberId ?? persona.userId;
  return {
    nickname: persona.nickname,
    entityType: persona.entityType ?? 'Character',
    entityId,
    gender: persona.gender,
    personality: persona.personality,
    ageGapType: persona.ageGapType,
    occupationType: persona.occupationType,
    occupationDescription: persona.occupationDescription,
    dataUrl: persona.dataUrl
  };
};

export const buildCastRelationshipBodyFromPersonas = (personas: {
  first: ScenePersona;
  second: ScenePersona;
}): CreateCastRelationshipBody => {
  return buildCreateCastRelationshipBody({
    memberA: toCastMemberInput(personas.first),
    memberB: toCastMemberInput(personas.second)
  });
};
